<h4 *ngIf="title">{{title}}</h4>
<ng-template [ngIf]="anagraficaForm">
	<form #f="ngForm" [formGroup]="anagraficaForm" (ngSubmit)="update();">
		<div class="row">

			<div ng-select-combo class="col-sm-3"
				formControlName="tipoPersona"
				[label]="'Tipo persona'"
				[required]="true"
				[options]="tipoPersonaOptions"
				[optionSel]="request.tipoPersona"
				(onChangeSel)="request.tipoPersona = $event; anagraficaForm.controls['tipoPersona'].setValue($event);request.sesso=null;request.vivente=null;changeTipoPersona(request.tipoPersona)">
			</div>

			<div textInput [control]="anagraficaForm.controls['nome']" [checkFormat]="true" class="col-sm-3"
				[labelInput]="'Nome'" formControlName="nome"
				[mandatory]="request.tipoPersona && request.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA"
				[(ngModel)]="request.nome"></div>

			<div textInput [control]="anagraficaForm.controls['cognome']" [checkFormat]="true"
				[mandatory]="request.tipoPersona && request.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA"
				class="col-sm-3" [labelInput]="'Cognome'" formControlName="cognome" [autocomplete]="'family-name'" [(ngModel)]="request.cognome"></div>


      <div *ngIf="!inserimento" textInput [control]="anagraficaForm.controls['nominativoOriginale']" class="col-sm-3"
           [labelInput]="'Nominativo Originale'"
           formControlName="nominativoOriginale" [(ngModel)]="request.nominativoOriginale"></div>

			<div *ngIf="inserimento" textInput [control]="anagraficaForm.controls['codiceFiscale']" [maxLength]="'16'"
				class="col-sm-3" [labelInput]="'Codice fiscale'" [checkFormat]="true" formControlName="codiceFiscale"
        [mandatory]="request.tipoPersona && request.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA"
				[(ngModel)]="request.codiceFiscale"></div>

		</div>

    <div class="row" *ngIf="!inserimento">
      <div textInput [control]="anagraficaForm.controls['codiceFiscale']" [maxLength]="'16'"
           class="col-sm-3" [labelInput]="'Codice fiscale'" [checkFormat]="true" formControlName="codiceFiscale"
           [mandatory]="request.tipoPersona && request.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA"
           [(ngModel)]="request.codiceFiscale"></div>
    </div>

		<!--<div class="row">

    <ng-template [ngIf]="hasConvenzione()">
      <div checkBoxRadio class="col-sm-4"
           [labelInput]="'Convenzione'" idInput="convenzione"
           formControlName="convenzione" [objectReference]="request.convenzione"
           (onReturn)="request.convenzione = $event"></div>
    </ng-template>

    <ng-template [ngIf]="hasTariffa()">
      <div textInput [control]="anagraficaForm.controls['tariffa']"
           class="col-sm-4" [labelInput]="'Tariffa'"
           [(ngModel)]="request.tariffa" formControlName="tariffa"></div>
    </ng-template>

  </div>-->

		<div class="row">

			<div checkBoxRadio [class]="isLegali ? 'col-sm-6':'col-sm-4'" [labelInput]="'Dipendente'"
				[idInput]="inserimento ? 'dipendente-ins' : 'dipendente-mod'" formControlName="dipendente"
				[control]="anagraficaForm.controls['dipendente']" [objectReference]="request.dipendente"
				(onReturn)="request.dipendente = $event; changedDipendente($event);">
			</div>

			<div textInput [control]="anagraficaForm.controls['matricola']" [class]="isLegali ? 'col-sm-6':'col-sm-4'"
				[labelInput]="'Matricola'" [checkFormat]="true" formControlName="matricola"
				[(ngModel)]="request.matricola" [submitPending]="!request.dipendente"
				[mandatory]="false"></div>

			<div comboModInput *ngIf="!isLegali" class="col-sm-4" [labelOption]="'nome'" [labelInput]="'Società'"
				formControlName="societa" [optionsCombo]="tipisocietaOptions" [objectReference]="request.societa"
				[(ngModel)]="request.societa" (onReturn)="request.societa = $event;" [mandatory]="false"
				(ngModelChange)="request.societa ? getTipiContrattoBySocieta(request.societa.id) : null"></div>

		</div>
		<div class="row" *ngIf="request.tipoPersona && request.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">


			<div checkBoxRadio
			[labelInput]="'Sesso'"
			class="col-sm-3"
			[mandatory]="true"
			[labelChecked]="'M'"
			[labelNotChecked]="'F'"
			formControlName="sesso"
			[control]="anagraficaForm.controls['sesso']"
			[objectReference]="sessoSelected"
			(onReturn)="onChangeSesso($event)"></div>

			<div checkBoxRadio *ngIf="isControparti && isFascicoloSanitario()"
			class="col-sm-3"
			[labelInput]="'Vivente'"
			[idInput]="inserimento ? 'vivente-ins' : 'vivente-mod'"
			formControlName="vivente"
			[control]="anagraficaForm.controls['vivente']"
			[objectReference]="request.vivente"
			(onReturn)="request.vivente = $event;">
			</div>

		</div>

		<div class="row">

			<div textInput [control]="anagraficaForm.controls['ragioneSociale']" class="col-sm-3"
				[labelInput]="'Ragione Sociale'"
				[mandatory]="request.tipoPersona && request.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA"
				formControlName="ragioneSociale" [(ngModel)]="request.ragioneSociale"></div>

			<div textInput [control]="anagraficaForm.controls['partitaIva']" [maxLength]="'11'" class="col-sm-3"
				[labelInput]="'Partita Iva'" [checkFormat]="true" formControlName="partitaIva"
        [mandatory]="request.tipoPersona && request.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA"
				[(ngModel)]="request.partitaIva"></div>

			<div textInput [control]="anagraficaForm.controls['codiceFiscaleRappresentanteLegale']" [maxLength]="'16'"
				class="col-sm-3" [labelInput]="'CF Rappresentante legale'" [checkFormat]="true"
				formControlName="codiceFiscaleRappresentanteLegale"
				[(ngModel)]="request.codiceFiscaleRappresentanteLegale"></div>

			<div comboModInput class="col-sm-3" [labelInput]="'Tipo societ&agrave;'" formControlName="tipoSocieta"
				[objectReference]="request.tipoSocieta" (onReturn)="request.tipoSocieta = $event"
				[optionsCombo]="tipiSocieta"></div>

		</div>
		<div class="row">
			<fieldset class="form-group">
				<legend>Nascita <span class="sr-only">controparte</span></legend>

				<div datePickerInput class="col-sm-4" [dataAl]="dataToday" [labelInput]="'Data di nascita'"
					formControlName="dataNascita" [(ngModel)]="request.dataNascita"></div>

				<div comboModInput class="col-sm-4" (change)="changeProvinciaNascita(request.provinciaNascita.id)"
					[labelInput]="'Provincia di nascita'" formControlName="provinciaNascita"
					[objectReference]="request.provinciaNascita" (onReturn)="request.provinciaNascita = $event"
					[optionsCombo]="provinceOptions"></div>

				<div comboModInput class="col-sm-4" [labelInput]="'Comune di nascita'" formControlName="comuneNascita"
					[objectReference]="request.comuneNascita" (onReturn)="request.comuneNascita = $event"
					[optionsCombo]="comuniNascitaOptions"></div>

			</fieldset>
		</div>
		<div class="row">
			<fieldset class="form-group">
				<legend>Residenza <span class="sr-only">controparte</span></legend>

				<div textInput [control]="anagraficaForm.controls['indirizzo']" class="col-sm-12"
					[labelInput]="'Indirizzo di residenza'" formControlName="indirizzo" [name]="'street-address'" [(ngModel)]="request.indirizzo">
				</div>

				<div naturalNumberInput [control]="anagraficaForm.controls['cap']" [maxLength]="'5'"
					[checkFormat]="true" class="col-sm-4" [checkFormat]="true" [labelInput]="'Cap'"
					formControlName="cap" [(ngModel)]="request.cap"></div>

				<div comboModInput class="col-sm-4" (change)="changeProvinciaResidenza(request.provinciaResidenza.id)"
					[labelInput]="'Provincia di residenza'" formControlName="provinciaResidenza"
					[objectReference]="request.provinciaResidenza" (onReturn)="request.provinciaResidenza = $event"
					[optionsCombo]="provinceOptions" [ngModel]="request.provinciaResidenza"></div>

				<div comboModInput class="col-sm-4" [labelInput]="'Comune di residenza'"
					formControlName="comuneResidenza" [objectReference]="request.comuneResidenza"
					(onReturn)="request.comuneResidenza = $event" [optionsCombo]="comuniResidenzaOptions"></div>

			</fieldset>
		</div>
		<ng-template [ngIf]="false"> <!--isControparte (da mettere nell'IF)-->
			<div class="row container_fieldset">
				<fieldset class="form-group">
					<legend>Dati profilo professionale <span class="sr-only">controparte</span></legend>

					<!-- <div comboModInput class="col-sm-4" [labelInput]="'Figura professionale'"
						formControlName="provinciaNascita" [objectReference]="request.figuraProfessionale"
						(onReturn)="request.figuraProfessionale = $event" [optionsCombo]="figureprofessionaliOptions">
					</div> -->
					<div textInput class="col-sm-4" [labelInput]="'Albo'" [control]="anagraficaForm.controls['albo']"
						formControlName="albo" [(ngModel)]="request.albo" [mandatory]="true"></div>

					<div textInput class="col-sm-4" [labelInput]="'N&deg; iscrizione albo'"
						[control]="anagraficaForm.controls['numeroIscrizione']" formControlName="numeroIscrizione"
						[(ngModel)]="request.numeroIscrizione"></div>

					<div textInput class="col-sm-4" [labelInput]="'Codice Cassa'" formControlName="codiceMeccanografico"
						[control]="anagraficaForm.controls['codiceMeccanografico']"
						[(ngModel)]="request.codiceMeccanografico"></div>

				</fieldset>
			</div>
		</ng-template>
		<div class="row">
			<fieldset class="form-group">
				<legend>Contatti <span class="sr-only">controparte</span></legend>

				<div textInput [control]="anagraficaForm.controls['telefono']" [maxLength]="'25'" class="col-sm-4"
					[labelInput]="'Telefono'" [checkFormat]="true" formControlName="telefono" [autocomplete]="'tel'"
					[(ngModel)]="request.telefono"></div>

				<div textInput [control]="anagraficaForm.controls['cellulare']" [maxLength]="'25'" class="col-sm-4"
					[labelInput]="'Cellulare'" [checkFormat]="true" formControlName="cellulare" [autocomplete]="'tel'"
					[(ngModel)]="request.cellulare"></div>

				<div textInput [control]="anagraficaForm.controls['fax']" [maxLength]="'25'" class="col-sm-4"
					[labelInput]="'N fax'" formControlName="fax" [(ngModel)]="request.fax" [checkFormat]="true"></div>

				<div textInput [control]="anagraficaForm.controls['email']" class="col-sm-6" [labelInput]="'Email'"
					formControlName="email" [(ngModel)]="request.email" [autocomplete]="'email'" [checkFormat]="true"></div>

				<div textInput [control]="anagraficaForm.controls['pec']" class="col-sm-6" [labelInput]="'Pec'"
					formControlName="pec" [(ngModel)]="request.pec" [autocomplete]="'email'" [checkFormat]="true"></div>

			</fieldset>
		</div>
		<ng-template [ngIf]="hasAmbitiCompetenza()">
			<div class="row">
				<fieldset class="form-group">
					<legend>Ambiti di competenza <span class="sr-only">controparte</span></legend>
					<div checkListInput formControlName="ambitiCompetenza" [(ngModel)]="request.ambitiCompetenza"
						[checkListOptions]="ambitiCompetenzaOptions" [idInput]="'ambitiCompetenza'"></div>
				</fieldset>
			</div>
		</ng-template>
		<div class="row">
			<div textAreaInput class="col-sm-12" [labelInput]="'Note'" formControlName="note"
				[(ngModel)]="request.note"></div>
		</div>
		<div class="row">
			<p class="mandatory col-sm-12">
				<em>* Campi obbligatori</em>
			</p>
		</div>
		<div class="row">
			<p class="col-sm-3 col-xs-6">
				<button type="button" class="btn btn-outline-secondary btn-block" (click)="createForm();">Reset</button>
			</p>
			<p submitButton [disabled]="!anagraficaValidator() || !anagraficaForm.valid"
				class="col-sm-3 col-xs-6 col-sm-offset-6"
				[labelButton]="inserimento ? labelButton : 'Salva'"></p>
		</div>
	</form>
</ng-template>